import { css } from 'lit';
export default css `
  :host {
    display: block;
    width: var(--local-size);
    height: var(--local-size);
  }

  :host svg {
    width: 100%;
    height: 100%;
  }
`;
//# sourceMappingURL=styles.js.map